import React from 'react';
import styles from './Button.module.scss';

export type ButtonType = 'primary' | 'secondary' | 'outline' | 'text' | 'danger' | 'success' | 'info' | 'warning';

interface ButtonProps {
  text: string;
  variant?: ButtonType;
  onClick?: (x:any) => void;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  form?: string;
  leftIcon? : React.ReactNode;
  rightIcon? : React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  text,
  variant = 'primary',
  onClick,
  className = '',
  disabled = false,
  type = "button",
  form,
  leftIcon,
  rightIcon,
}) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
      form={form}
    >
      {leftIcon}{text}{rightIcon}
    </button>
  );
};

export default Button;

interface TableActionButtonProps {
  onClick: () =>  void;
}
export const TableActionButton =({ onClick }: TableActionButtonProps) =>(
  <button className={styles.actionButton} onClick={onClick}>
					VIEW DETAILS
				</button>
)